export const defaultPrimaryActions = type => ['factuur', 'creditnota'].includes(type)
  ? ['pdf', 'billit', 'email', 'edit', 'download'] : type === 'inkomend' ? ['edit', 'pay', 'approve'] : ['pdf', 'email', 'edit', 'download', 'dup'];

const COMMON = [
  { key: 'pdf', label: 'PDF bekijken' }, { key: 'download', label: 'PDF downloaden' },
  { key: 'print', label: 'Afdrukken', group: 'pdf' }, { key: 'email', label: 'E-mail versturen' },
  { key: 'edit', label: 'Bewerken' }, { key: 'dup', label: 'Dupliceren' },
  { key: 'share', label: 'Delen via andere apps', group: 'download' }, { key: 'whatsapp', label: 'WhatsApp PDF', group: 'download' },
];
export const directActionOptions = type => {
  if (type === 'inkomend') return [{ key: 'edit', label: 'Document openen' }, { key: 'pay', label: 'Betaling bevestigen' }, { key: 'approve', label: 'Goedkeuren' }];
  const options = [...COMMON];
  if (['factuur', 'creditnota'].includes(type)) options.push({ key: 'billit', label: 'BE → Billit' });
  if (type === 'factuur') options.push({ key: 'cn', label: 'Creditnota maken' }, { key: 'pay', label: 'Betaallink' });
  if (type === 'leverbon') options.push(...[
    ['chauffeur', 'WhatsApp chauffeur'], ['cmr', 'CMR vrachtbrief'], ['etiket', 'Adresetiketten'],
    ['verzendmelding', 'Verzendmelding'], ['handtekening', 'Ondertekenen'],
  ].map(([key, label]) => ({ key, label })));
  if (type === 'bestelbon') options.push({ key: 'deellevering', label: 'Gedeeltelijke levering' }, { key: 'shop-confirm', label: 'Bestelling bevestigen' }, { key: 'shop-reject', label: 'Bestelling weigeren' });
  if (['offerte', 'bestelbon', 'leverbon', 'proforma'].includes(type)) {
    const conversions = { offerte: ['bestelbon', 'leverbon', 'proforma', 'factuur'], bestelbon: ['leverbon', 'factuur'], leverbon: ['factuur'], proforma: ['factuur', 'leverbon', 'bestelbon'] }[type];
    for (const target of conversions) options.push({ key: `convert-${target}`, label: `Omzetten naar ${target}`, group: 'convert' });
  }
  options.push({ key: 'del', label: 'Verwijderen' });
  return options;
};

export const rowActionKey = (child, id) => {
  const testId = child.props['data-testid'] || child.props.testid || '';
  if (testId.startsWith(`convert-${id}-`)) return `convert-${testId.slice(`convert-${id}-`.length)}`;
  const raw = testId.endsWith(`-${id}`) ? testId.slice(0, -id.length - 1) : testId;
  return ({ 'billit-push': 'billit', 'remote-print': 'print', 'share-pdf': 'share', 'whatsapp-pdf': 'whatsapp',
    'chauffeur-adres': 'chauffeur', 'deellevering-btn': 'deellevering', 'meld-verzending': 'verzendmelding', sign: 'handtekening',
    'factuur-maken': 'convert-factuur', 'shop-bevestig': 'shop-confirm', 'shop-weiger': 'shop-reject',
    'betaling-bevestigen': 'pay', 'snel-goedkeur': 'approve', 'incoming-open': 'edit' })[raw] || raw;
};